<template>
  <section class="faq-widget">
    <div class="grid">
      <WidgetHeading
        :is-first="isFirst"
        :is-big="isFirst"
        class="title"
        :content="widget.title"
      />
    </div>
    <div class="sections">
      <article
        v-for="(section, index) in widget.sections"
        :key="index"
        class="section grid"
      >
        <h3 class="section-title t-h1" v-html="section.subtitle" />
        <AccordionsList
          :id="`${widget.id}_${index}`"
          :only-one-active="false"
          :items="getItems(section)"
          title-tag="h4"
        />
      </article>
    </div>
  </section>
</template>

<script lang="ts" setup>
import { PublicFaqSection, PublicFaqWidget } from '@/service/__generated-api'
import { Widget } from '@/types/utils'

defineProps<Widget<PublicFaqWidget>>()

const getItems = (section: PublicFaqSection) =>
  section.items.map(({ answer, question }) => ({
    title: question,
    content: answer
  }))
</script>

<style lang="scss" scoped>
.title {
  @include media-column(
    (
      xs: 4,
      md: 8,
      lg: 12
    )
  );
}

.section {
  padding-top: rem(40px);

  @include media-up(lg) {
    padding-top: rem(56px);
  }

  &:first-of-type {
    padding-top: rem(64px);

    @include media-up(lg) {
      padding-top: rem(72px);
    }
  }
}

.section-title {
  @include media-column(
    (
      xs: 4,
      md: 8,
      lg: 6
    )
  );
  margin-bottom: rem(32px);

  @include media-up(lg) {
    margin-bottom: 0;
  }
}

.list {
  @include media-column(
    (
      xs: 4,
      md: 8,
      lg: 6 6
    )
  );
  row-gap: 0;
}
</style>
